import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../store/actions";
import "../styles/sidebar.css";

import Sidebar from "./VerticalLayout/Sidebar";
import RightSidebar from "./CommonForBoth/RightSidebar";
import AppTopbar from "./AppTopbar";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      mobileSidebarOpen: false,
    };
  }

  componentDidMount() {
    const preloader = document.getElementById("preloader");
    const status = document.getElementById("status");

    if (preloader && status) {
      if (this.props.isPreloader === true) {
        preloader.style.display = "block";
        status.style.display = "block";
        setTimeout(() => {
          preloader.style.display = "none";
          status.style.display = "none";
        }, 2500);
      } else {
        preloader.style.display = "none";
        status.style.display = "none";
      }
    }

    window.scrollTo(0, 0);

    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    }
    if (this.props.leftSideBarThemeImage) {
      this.props.changeSidebarThemeImage(this.props.leftSideBarThemeImage);
    }
    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }
    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
  }

  toggleMobileSidebar = () => {
    this.setState((state) => ({
      mobileSidebarOpen: !state.mobileSidebarOpen,
    }));
  };

  closeMobileSidebar = () => {
    this.setState({ mobileSidebarOpen: false });
  };

  render() {
    const { mobileSidebarOpen } = this.state;

    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
            </div>
          </div>
        </div>

        <div
          id="layout-wrapper"
          className={mobileSidebarOpen ? "sidebar-is-open" : ""}
        >
          <Sidebar
            theme={this.props.leftSideBarTheme}
            type={this.props.leftSideBarType}
            isMobile={this.state.isMobile}
            isOpen={mobileSidebarOpen}
            onNavigate={this.closeMobileSidebar}
          />

          <button
            type="button"
            className="app-sidebar-backdrop"
            aria-label="Close navigation"
            onClick={this.closeMobileSidebar}
          />

          <div className="app-workspace">
            <AppTopbar onMenuClick={this.toggleMobileSidebar} />
            <main className="main-content">{this.props.children}</main>
          </div>
        </div>

        {this.props.showRightSidebar ? <RightSidebar /> : null}
      </React.Fragment>
    );
  }
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.node,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

const mapStatetoProps = (state) => ({
  ...state.Layout,
});

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(Layout);

// import PropTypes from 'prop-types'
// import React, { Component } from "react"

// import { connect } from "react-redux"
// // import { withRouter } from "react-router-dom"
// import {
//   changeLayout,
//   changeSidebarTheme,
//   changeSidebarThemeImage,
//   changeSidebarType,
//   changeTopbarTheme,
//   changeLayoutWidth,
// } from "../store/actions"
// import "../styles/sidebar.css";

// // Layout Related Components
// import Header from "./VerticalLayout/Header"
// import Sidebar from "./VerticalLayout/Sidebar"
// import Footer from "./VerticalLayout/Footer"
// import RightSidebar from "./CommonForBoth/RightSidebar"

// class Layout extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
//     }
//     this.toggleMenuCallback = this.toggleMenuCallback.bind(this)
//   }

//   capitalizeFirstLetter = string => {
//     return string.charAt(1).toUpperCase() + string.slice(2)
//   }

//   componentDidMount() {
//     if (this.props.isPreloader === true) {
//       document.getElementById("preloader").style.display = "block"
//       document.getElementById("status").style.display = "block"

//       setTimeout(function () {
//         document.getElementById("preloader").style.display = "none"
//         document.getElementById("status").style.display = "none"
//       }, 2500)
//     } else {
//       document.getElementById("preloader").style.display = "none"
//       document.getElementById("status").style.display = "none"
//     }

//     // Scroll Top to 0
//     window.scrollTo(0, 0)
//     // let currentage = this.capitalizeFirstLetter(this.props.location.pathname)

//     // document.title =
//     //   currentage + " | Skote - React Admin & Dashboard Template"
//     if (this.props.leftSideBarTheme) {
//       this.props.changeSidebarTheme(this.props.leftSideBarTheme)
//     }
//     if (this.props.leftSideBarThemeImage) {
//       this.props.changeSidebarThemeImage(this.props.leftSideBarThemeImage)
//     }

//     if (this.props.layoutWidth) {
//       this.props.changeLayoutWidth(this.props.layoutWidth)
//     }

//     if (this.props.leftSideBarType) {
//       this.props.changeSidebarType(this.props.leftSideBarType)
//     }
//     if (this.props.topbarTheme) {
//       this.props.changeTopbarTheme(this.props.topbarTheme)
//     }
//   }
//   toggleMenuCallback = () => {
//     if (this.props.leftSideBarType === "default") {
//       this.props.changeSidebarType("condensed", this.state.isMobile)
//     } else if (this.props.leftSideBarType === "condensed") {
//       this.props.changeSidebarType("default", this.state.isMobile)
//     }
//   }
//   render() {
//     return (
//       <React.Fragment >
//         <div id="preloader">
//           <div id="status">
//             <div className="spinner-chase">
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//               <div className="chase-dot" />
//             </div>
//           </div>
//         </div>

//         <div id="layout-wrapper" >
//           {/* <Header toggleMenuCallback={this.toggleMenuCallback} /> */}
//           <Sidebar className="hello"
//             theme={this.props.leftSideBarTheme}
//             type={this.props.leftSideBarType}
//             isMobile={this.state.isMobile}
//           />
//           <div className="main-content">{this.props.children}</div>
//           {/* <Footer /> */}
//         </div>
//         {this.props.showRightSidebar ? <RightSidebar /> : null}
//       </React.Fragment>
//     )
//   }
// }

// Layout.propTypes = {
//   changeLayoutWidth: PropTypes.func,
//   changeSidebarTheme: PropTypes.func,
//   changeSidebarThemeImage: PropTypes.func,
//   changeSidebarType: PropTypes.func,
//   changeTopbarTheme: PropTypes.func,
//   children: PropTypes.object,
//   isPreloader: PropTypes.any,
//   layoutWidth: PropTypes.any,
//   leftSideBarTheme: PropTypes.any,
//   leftSideBarThemeImage: PropTypes.any,
//   leftSideBarType: PropTypes.any,
//   location: PropTypes.object,
//   showRightSidebar: PropTypes.any,
//   topbarTheme: PropTypes.any
// }

// const mapStatetoProps = state => {
//   return {
//     ...state.Layout,
//   }
// }
// export default connect(mapStatetoProps, {
//   changeLayout,
//   changeSidebarTheme,
//   changeSidebarThemeImage,
//   changeSidebarType,
//   changeTopbarTheme,
//   changeLayoutWidth,
// })(Layout)
